import { render } from "./AnalyticsDataBlock.vue?vue&type=template&id=279ee2a2&scoped=true"
import script from "./AnalyticsDataBlock.vue?vue&type=script&lang=js"
export * from "./AnalyticsDataBlock.vue?vue&type=script&lang=js"

import "./AnalyticsDataBlock.vue?vue&type=style&index=0&id=279ee2a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-279ee2a2"]])

export default __exports__